import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VisitorsFormLayer from "../components/VisitorsFormLayer";

const VisitorsFormPage = () => {
    return (
        <MasterLayout>
            <VisitorsFormLayer />
        </MasterLayout>
    );
};

export default VisitorsFormPage;
